<template>
  <div class="d-lg-none">
    <button
      v-show="isCollapsed"
      class="view-option-collapse-button view-options-color btn bg-white"
      type="button"
      @click="toggleCollapse"
      aria-label="toggle navigation side panel"
    >
      <span>{{ $resourceString['product.Details.Label.ViewOptions'] }}</span>
      <span
        class="png-icon mx-2"
        :class="
          isCollapsed
            ? 'png-icon-icons-glyph--g-mobile-menu'
            : 'png-icon-icons-glyph--g-close'
        "
      ></span>
    </button>

    <div
      class="bg-white view-options-color collapse view-option-collapse-button-expand container"
      :class="{ show: !isCollapsed }"
      id="view-options-collapse"
    >
      <button
        class="btn justify-content-end w-100 p-0 view-options-color"
        type="button"
        @click="toggleCollapse"
      >
        {{ $resourceString['product.Details.Label.ViewOptions'] }}
        <span class="png-icon png-icon-icons-glyph--g-close mx-2"></span>
      </button>

      <div class="pl-3 text-capitalize">
        <h6>{{ $resourceString['product.Details.Label.ViewOptions'] }}</h6>
        <label
          v-for="(option, index) in filteredViewOptions"
          :key="index"
          class="custom-control custom-radio mr-4 cursor-pointer"
        >
          <input
            type="radio"
            :id="`${option.value}`"
            class="custom-control-input"
            :name="option.name"
            :value="option.value"
            v-model="selectedViewOption"
            @change="emitViewOptionChange"
          />
          <div class="custom-control-label">
            <div class="align-items-center d-flex font-size-18">
              <span>{{ option.label }}</span>
            </div>
          </div>
        </label>
      </div>

      <div class="pl-3 text-capitalize mt-4">
        <h6>{{ $resourceString['product.Details.Label.ViewOptions.InstallationMethod'] }}</h6>
        <label
          v-for="(option, index) in installationMethods"
          :key="index"
          class="custom-control custom-radio mr-4 cursor-pointer"
        >
          <input
            type="radio"
            :id="`${option.tricycleCode}`"
            class="custom-control-input"
            :name="option.name"
            :value="option.tricycleCode || option.code"
            v-model="selectedInstallOption"
            @change="emitInstallOptionChange(option)"
          />
          <div class="custom-control-label">
            <div class="align-items-center d-flex font-size-18">
              <span>{{ option.name }}</span>
            </div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["installationMethods"],
  data() {
    return {
      isCollapsed: true,
    };
  },

  computed: {
    ...mapGetters({
      selectedInstallationMethod: "productDetail/installationMethod",
      getViewOptions: "productDetail/getViewOptions",
      productData: "productDetail/productData",
    }),

    selectedInstallOption: {
      get() {
        return this.selectedInstallationMethod.tricycleCode ?? this.selectedInstallationMethod?.code;
      },
      set(value) {},
    },

    selectedViewOption: {
      get() {
        return this.getViewOptions;
      },
      set(value) {
        this.setViewOptions(value);
      },
    },

    isNonTiledProductType() {
      if (!this.productData) return false;

      const resinousType = this.$resourceString["productCategory.ResinousFlooring"];
      const broadloomType = this.$resourceString["productCategory.Broadloom"];
      const sheetType = this.$resourceString["productCategory.Sheet"];

      return (
        this.productData.productFormDesc?.toLowerCase() === resinousType.toLowerCase() ||
        this.productData.productFormDesc?.toLowerCase() === broadloomType.toLowerCase() ||
        this.productData.productFormDesc?.toLowerCase() === sheetType.toLowerCase() ||
        this.productData.productTypeDesc?.toLowerCase() === sheetType.toLowerCase()
      );
    },

    filteredViewOptions() {
      const options = [
        {
          label: this.$resourceString["product.Details.Label.SingleSwatch"],
          value: "swatch",
        },
        {
          label: this.$resourceString["product.Details.Label.MultiTile"],
          value: "multi",
        },
        {
          label: this.$resourceString["product.search.display.room.view"],
          value: "room",
        },
        {
          label: this.$resourceString["product.Details.Label.360Video"],
          value: "360Video",
        },
      ];

      return this.isNonTiledProductType
        ? options.filter((option) => option.value !== "multi")
        : options;
    },
  },

  methods: {
    ...mapActions({
      setViewOptions: "productDetail/setViewOptions",
    }),

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    emitViewOptionChange() {
      this.$emit("view-option-changed", this.selectedViewOption);
    },

    emitInstallOptionChange(value) {
      this.$emit("install-option-changed", value);
    },
  },
};
</script>

<style scoped></style>
